import React from 'react';
import { StyledButton } from '../../styles/StyledButtons';
import { Article } from '../../../models/Article';

interface ArticleApprovalStatusButtonsProps {
  article: Article;
  isProcessing: boolean;
  hasRunningJob: boolean;
  onPublish: () => void;
  onArchive: () => void;
  onUnarchive: () => void;
  onRegenerate: () => void;
}

export default function ArticleApprovalStatusButtons({
  article,
  isProcessing,
  hasRunningJob,
  onPublish,
  onArchive,
  onUnarchive,
  onRegenerate,
}: ArticleApprovalStatusButtonsProps) {
  const status = article.status.toLowerCase();
  const disabled = isProcessing || hasRunningJob;

  switch (status) {
    case 'published':
      return (
        <StyledButton onClick={onArchive} disabled={disabled}>
          Archive
        </StyledButton>
      );

    case 'pending_preview':
      return (
        <>
          <StyledButton onClick={onPublish} disabled={disabled}>
            Publish
          </StyledButton>
          <StyledButton onClick={onRegenerate} disabled={disabled}>
            Regenerate
          </StyledButton>
          <StyledButton onClick={onArchive} disabled={disabled}>
            Archive
          </StyledButton>
        </>
      );

    case 'failed':
      return (
        <>
          <StyledButton onClick={onRegenerate} disabled={disabled}>
            Regenerate
          </StyledButton>
          <StyledButton onClick={onArchive} disabled={disabled}>
            Archive
          </StyledButton>
        </>
      );

    case 'archived':
      return (
        <StyledButton onClick={onUnarchive} disabled={disabled}>
          Unarchive
        </StyledButton>
      );

    default:
      return (
        <StyledButton onClick={onRegenerate} disabled={disabled}>
          Regenerate
        </StyledButton>
      );
  }
}
